export const sxStyle = {
  sliderContainer: {
    width: '100%',
    height: { xs: 160, sm: 325 }, // altura fija/responsive
    overflow: 'hidden',
  },
  slide: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: { xs: 160, sm: 325 }, // altura exacta por breakpoint
    width: '100%',
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', // corta la imagen si no encaja
  },
};
